import {FieldState, FormState} from "formstate";
import {email, required} from "app/modules/common/form/validators";
import {action, makeObservable, observable, runInAction} from "mobx";
import {inject} from "react-ioc";
import {ApiClients} from "app/modules/external/services/AxiosBaseClient";
import {ApiErrorHandler} from "app/modules/common/static/ErrrorHandler";
import {BaseStore} from "app/modules/auth/services/BaseStore";

export class SaleStore extends BaseStore {
    @inject apiClients: ApiClients;

    isLoading: boolean = false;
    isRequestSent: boolean = false;
    errorMessage: string = null;

    formState = new FormState({
        email: new FieldState('').validators(required, email),
        phone: new FieldState('').validators(required),
        fullName: new FieldState('').validators(required),
        text: new FieldState('').validators(required),
    });

    constructor() {
        super();

        makeObservable(this, {
            isLoading: observable,
            isRequestSent: observable,
            errorMessage: observable,

            submitEnquiry: action
        });
    }

    submitEnquiry = async () => {
        this.errorMessage = null;

        await this.formState.validate();

        if(this.formState.hasError) {
            return;
        }

        runInAction(() => { this.isLoading = true; })

        this.executeRecaptcha(async (token) => {
            try {
                await this.apiClients.salesClient.submitEnquiry(this.formState.$.phone.value, this.formState.$.email.value, this.formState.$.fullName.value, this.formState.$.text.value, token);

                runInAction(() => { this.isRequestSent = true; });
            } catch(ex) {
                if(!ex.isCodedExceptionApi) {
                    runInAction(() => {
                        runInAction(() => { this.errorMessage = "Unexpected error, please try again later"; });
                    });
                }

                ApiErrorHandler(ex);
            }
            finally {
                runInAction(() => { this.isLoading = false; })
            }
        });
    }
}
